import { ColorTokens, FontSizeTokens, IconTokens, } from '@voltmoney/schema';
export const args = {
    // customTitle: {
    // 	label: "Custom data",
    // 	fontSize: FontSizeTokens.SM,
    // 	fontWeight: '600',
    // 	color: ColorTokens.Primary_100
    // },
    title: 'PAN NumberPAN NumberPAN NumberPAN NumberPAN NumberPAN NumberPAN NumberPAN NumberPAN NumberPAN Number',
    subTitle: 'BFTPB2772K',
    trailLabel: {
        label: 'Custom data',
        fontSize: FontSizeTokens.SM,
        fontWeight: '600',
        color: ColorTokens.Primary_100,
    },
    //trailIconName: IconTokens.Cake,
    //leadIconName: IconTokens.Fire,
    onPress: () => { },
};
export const argTypes = {
    trailIconName: {
        control: 'select',
        options: [
            ...Object.values(IconTokens).filter((k) => typeof k === 'string'),
        ],
    },
    onPress: { action: 'clicked' },
};
